import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import EmailAddressViewWidget from "../../user-emails/view/EmailAddressViewWidget"
import UserViewItemDetails from "./UserViewItemDetails"
import UserViewRelatedPanelWidget from "../../user-related-panel/view/UserViewRelatedPanelWidget"

const UserViewItem = ({ model, onValueChange, isFetching }) => (
    <ItemDetailsColumns>
        <ItemDetailsColumn>
            <UserViewItemDetails
                bio={model.bio}
                first_name={model.first_name}
                last_name={model.last_name}
                status={model.status}
                primary_organisation={model.primary_organisation}
                primary_position={model.primary_position}
                photo_url={model.photo_url}
                isFetching={isFetching}
            />
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <EmailAddressViewWidget
                emails={model.emails}
                primary_email={model.primary_email}
                onValueChange={onValueChange}
                isFetching={isFetching}
            />
            <UserViewRelatedPanelWidget
                permission_groups={model.permission_groups}
                topics_followed={model.topics_followed}
                communities_followed={model.communities_followed}
                communities_member_of={model.communities_member_of}
                isFetching={isFetching}
            />
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default UserViewItem
